import { DiscountProduct } from '@/types/discount';
import { ProductDiscountCard } from '../cards/ProductDiscountCard';

interface RegisteredSectionProps {
  products: DiscountProduct[];
  type: 'deadline' | 'reservation';
  onDiscountRateChange: (productId: string, discountRate: number) => void;
  onStockChange: (productId: string, stock: number) => void;
  onPriceChange?: (productId: string, price: number) => void;
  onProductSelect: (productId: string) => void;
  onSelectAll?: (select: boolean) => void;
}

export function RegisteredSection({
  products,
  type,
  onDiscountRateChange,
  onStockChange,
  onPriceChange,
  onProductSelect,
  onSelectAll
}: RegisteredSectionProps) {
  // 실제로 등록된 상품들만 필터링 (DB에 등록되어 있거나 UI에서 선택된 상품)
  const registeredProducts = products.filter(p => p.selected || p.isRegisteredInDB);

  // 전체 선택 상태 계산
  const allSelected = registeredProducts.length > 0 && registeredProducts.every(p => p.selected);

  if (registeredProducts.length === 0) {
    return null;
  }

  return (
    <div className="mb-8">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center gap-3">
          <h3 className="text-lg font-semibold text-gray-800">
            등록된 {type === 'deadline' ? '마감할인' : '예약할인'} 상품
          </h3>
          {registeredProducts.length > 0 && onSelectAll && (
            <label className="flex items-center gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={(e) => onSelectAll(e.target.checked)}
                className="w-4 h-4 text-green-500 rounded focus:ring-2 focus:ring-green-500"
              />
              <span className="text-sm text-gray-600">전체 선택</span>
            </label>
          )}
        </div>
        <div className="flex items-center gap-2">
          <span className="bg-green-100 text-green-800 px-3 py-1 rounded-full text-sm font-medium">
            {registeredProducts.filter(p => p.isRegisteredInDB).length}개 DB 등록됨
          </span>
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-medium">
            {registeredProducts.filter(p => p.selected && !p.isRegisteredInDB).length}개 신규 선택됨
          </span>
        </div>
      </div>

      <div className="space-y-4">
        {registeredProducts.map((product) => (
          <ProductDiscountCard
            key={product.productId}
            product={product}
            type={type}
            onDiscountRateChange={onDiscountRateChange}
            onStockChange={onStockChange}
            onPriceChange={onPriceChange}
            onProductSelect={onProductSelect}
            isRegistered={true}
          />
        ))}
      </div>
    </div>
  );
}